import styled from 'styled-components/macro'

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FormHeaderHolder = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
  border-bottom: 1px solid var(--color-primary-200);
  padding-bottom: 16px;

  .address-select {
    width: 368px;
  }
`

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 16px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  > div,
  label {
    height: 70px;
  }
`

export const TextFieldGroup = styled.div`
  display: flex;
  gap: 8px;
  > div,
  label {
    flex: 1 1 0;
    width: 0;
  }
`

export const ClearFormButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
